import { render, staticRenderFns } from "./CoachMark.vue?vue&type=template&id=864782a2&scoped=true"
import script from "./CoachMark.vue?vue&type=script&lang=js"
export * from "./CoachMark.vue?vue&type=script&lang=js"
import style0 from "./CoachMark.vue?vue&type=style&index=0&id=864782a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864782a2",
  null
  
)

export default component.exports